import { NbDialogService } from '@nebular/theme';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ScopeService } from '../../../@core/utils';
import { map } from 'rxjs/operators';
import { AsyncPipe, NgClass } from '@angular/common';
import { EnergySettingsDialogComponent, EnergySettingsType } from '../energy-settings-dialog/energy-settings-dialog.component';

@Component({
    selector: 'app-energy-settings-fab',
    templateUrl: './energy-settings-fab.component.html',
    styleUrls: ['./energy-settings-fab.component.scss'],
    standalone: true,
    imports: [
      NgClass,
      AsyncPipe
    ],
})
export class EnergySettingsFabComponent implements OnInit {

  @Input() public class: 'fixed' | 'absolute' | "inflation" = 'fixed';
  @Input() public defaultSelectedTab: EnergySettingsType = 'energyObjectives';

  public energyEnabled$: Observable<boolean>;

  constructor(
    private dialogService: NbDialogService,
    private scopeService: ScopeService
    ) {}

  public ngOnInit(): void {
    this.energyEnabled$ = this.scopeService.user$.pipe(
      map((user) => user?.can_access_energy),
    )
  }

  public openEnergySettingsDialog(): void {
    this.dialogService.open(EnergySettingsDialogComponent, {
      autoFocus: false,
      context: {
        defaultSelectedTab: this.defaultSelectedTab,
      }
    });
  }

  public openInflationDialog(): void {
    this.dialogService.open(EnergySettingsDialogComponent, {
      autoFocus: false,
    });
  }
}
